import React, { useState } from "react";
import { downArrow, shareIcon } from "../../header/svg";

const renderMessageText = (text) => {
  const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;

  return text.split("\n").map((line, i, lines) => {
    const parts = [];
    let lastIndex = 0;
    let match;

    while ((match = urlRegex.exec(line)) !== null) {
      const url = match[0];
      const start = match.index;

      if (start > lastIndex) {
        parts.push(line.slice(lastIndex, start));
      }

      const href = url.startsWith("http") ? url : `https://${url}`;

      parts.push(
        <a
          key={`${i}-${start}`}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full mt-3 rounded-xl border border-[#0000001A] transition-all"
        >
          <div className="flex items-center p-3 gap-3">
            <div className="w-12 h-12  rounded-md overflow-hidden flex-shrink-0">
              <img
                src={`https://www.google.com/s2/favicons?sz=64&domain_url=${href}`}
                alt=""
                className="w-full h-full object-cover"
              />
            </div>

            <div className="flex flex-col flex-grow">
              <span className="text-[#155DFC] font-normal font-inter text-[16px] leading-tight">
                {href.replace(/^https?:\/\//, "").split("/")[0]}
              </span>
              <span className="text-[#6A7282] text-[12px] font-inter break-all">
                {href.replace(/^https?:\/\//, "")}
              </span>
            </div>

            <div className="text-gray-400 ml-auto">{shareIcon}</div>
          </div>
        </a>
      );

      lastIndex = urlRegex.lastIndex;
    }

    if (lastIndex < line.length) {
      parts.push(line.slice(lastIndex));
    }

    return (
      <React.Fragment key={i}>
        {parts}
        {i < lines.length - 1 && <br />}
      </React.Fragment>
    );
  });
};

export const MessageText = ({ text, limit = 180 }) => {
  const [expanded, setExpanded] = useState(false);

  if (!text || text.length <= limit) {
    return (
      <div className="text-[15px] text-[#364153] font-inter leading-relaxed">
        {renderMessageText(text)}
      </div>
    );
  }

  const shortText = text.slice(0, limit).trim() + "...";

  return (
    <div className="text-[15px] text-[#364153] font-inter leading-relaxed">
      {expanded ? renderMessageText(text) : renderMessageText(shortText)}

      <button
        type="button"
        onClick={() => setExpanded((prev) => !prev)}
        className="mt-2 flex items-center gap-1 text-[#155DFC] text-[14px] font-medium focus:outline-none"
      >
        {expanded ? "Read less" : "Read more"}
        <span
          className={
            expanded
              ? "rotate-180 transition-transform"
              : "transition-transform"
          }
        >
          {downArrow}
        </span>
      </button>
    </div>
  );
};
